import { FC } from 'react';
import styled from 'styled-components';

const Dashboard = styled.div`
  width: 100%;
  height: 100%;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 800px;
`;

const LoadingMessage = styled.div(({ theme }) => {
  return `
    font-size: ${theme.type.size.regular}
    text-align: cetner;
  `;
});

export interface IMetabaseDashboard {
  dashboardURL: string;
}

const MetabaseDashboard: FC<IMetabaseDashboard> = ({ dashboardURL }) => {
  return (
    <Dashboard>
      {dashboardURL === '' && <LoadingMessage>Loading your dashboard...</LoadingMessage>}
      {dashboardURL !== '' && <Iframe src={dashboardURL} />}
    </Dashboard>
  );
};

export default MetabaseDashboard;
